// extracted by mini-css-extract-plugin
export var modal = "_gu-0";